/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Integration_DetailsInputs */

const en_integration_details = /** @type {(inputs: Integration_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} details`)
};

const es_integration_details = /** @type {(inputs: Integration_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Detalles de ${i?.name}`)
};

/**
* | output |
* | --- |
* | "{name} details" |
*
* @param {Integration_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_details = /** @type {((inputs: Integration_DetailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_DetailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_details(inputs)
	return en_integration_details(inputs)
});